import styled from 'styled-components';
import { palette } from 'styled-tools';

import { fontSize, FontSizes, fontWeight, FontWeights, minWidth, Text } from '@calm-web/design-system';

import OnboardingNavButtons from '../../Components/OnboardingNavButtons';

export const Wrapper = styled.div`
	color: ${palette('gray7')};
	display: flex;
	flex-direction: column;
	flex-wrap: wrap;
	margin: 16px 0;

	${minWidth('tablet')} {
		flex-direction: row;
		margin: 0;
		min-height: 0;
	}
`;

export const TopContent = styled.div`
	& p {
		${fontWeight(FontWeights.Regular)};
		margin-bottom: 24px;
	}
`;

export const Heading = styled(Text).attrs({
	noMargin: true,
	lineHeight: FontSizes.xl,
	el: 'h1',
})`
	align-items: flex-start;
	display: flex;
	margin-bottom: 40px;
`;

export const Logo = styled.img`
	height: auto;
	margin: 0 4px;
	position: relative;
	top: 3.5px;
	width: 82px;
`;

export const OnboardingButtons = styled(OnboardingNavButtons)`
	margin-top: 72px;
`;

export const WelcomeMessage = styled.div`
	${fontWeight(FontWeights.Regular)};
	${fontSize(FontSizes.xl)};
`;
